/**
 * Una barra de avance pequeña con su número al lado.
 *
 * El número va siempre: el color dice «bien» o «mal» de lejos, la cifra dice
 * cuánto, y quien no distingue el rojo del verde lee la cifra.
 */
export function BarraDeAvance({
  valor,
  texto,
  tono = 'bueno',
  etiqueta,
}: {
  /** Entre 0 y 1. */
  valor: number;
  /** Lo que se lee junto a la barra: «3 / 5», «60 %». */
  texto: string;
  tono?: 'bueno' | 'aviso' | 'critico';
  /** Para lectores de pantalla, si el texto solo no basta. */
  etiqueta?: string;
}) {
  const porcentaje = Math.round(Math.min(1, Math.max(0, valor)) * 100);
  return (
    <span className="avance">
      <span
        className={`avance__barra avance__barra--${tono}`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={porcentaje}
        aria-label={etiqueta}
      >
        <span className="avance__relleno" style={{ width: `${porcentaje}%` }} />
      </span>
      <span className="avance__texto mono">{texto}</span>
    </span>
  );
}
